<template>
  <div style="margin-left: 20">
    <form id="form_id" ref="form" @submit.prevent="processForm" >
    <div class="container">
  <div class="row">
		<table>
		<tr>
				<td>
					<h3 style="margin-top:10;margin-left: 50;">Dashboard</h3>
				</td>
		</tr>
		</table>
  </div>
  </div>
      <div class="container">
        <div class="row">
          <table class="table-horizontal" width="30%" height="20">
            <tbody>
            
              <tr>
                <td><strong>Group Name</strong></td>
                <td><strong>Year</strong></td>
              </tr>
              <tr>
              
                <td v-if="groups.length ===1">
                <span>
							<input class="mumbai grayout"  readonly="true" v-model="group" @change="downloadData" >
							</span>

						</td>
						<td v-else>
						<span>
							<select  class="mumbai" v-model="group" @change="downloadData" >
									<option selected>-Select-</option>
									<option v-for="group in groups" v-bind:key="group.id"  v-bind:id="group" >{{group}}</option>
							</select>	
							</span>
						</td>
              <td >
              <span>
                  <select  class="mumbai" v-model="year" @change="downloadData" >
                    <option selected>-Select-</option>
                    <option v-for="year in years" v-bind:key="year.id"  v-bind:id="year" >{{year}}</option>
                  </select>	
                  </span>
                </td>
              </tr>
            
            </tbody>
          </table>
  
        </div>
      </div>
    </form>
  </div>
  
  <figure class="highcharts-figure">
    <div id="container">
      <highcharts v-if="group !=='-Select-' && year !=='-Select-'" class="hc" :options="chartOptions" ref="chart"></highcharts>
    </div>
  </figure>
</template>

<script>
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
// import {Chart} from 'highcharts-vue'
import axios from 'axios';
import moment from 'moment';
import store from '@/store'

exportingInit(Highcharts);


      
export default {
computed : {
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 2019}, (value, index) => 2020 + index)
    }
  },
  data() {
    return {
      chartOptions: {},
      groups : [],
      group : '-Select-',
      year : '-Select-',
      responseData : {},
      convertedObj : {},
      options : {},
      monthArray : [],
      requestRaised :[],
      responseRaised :[],
      responsePercent : []
    };
  },created: function(){
		
		this.groups =store.methods.getGroup();
	
		if(this.groups.length ===1)
		{
			this.group = this.groups[0];		
    }
    if(this.group !=='-Select-' && this.year !=='-Select-')
      this.downloadData();
	},
  methods: {
  getDataPromise () {
    let dashboardUri;

    dashboardUri = process.env.VUE_APP_BACKEND_API+"dashboard?"
    +"&group="+this.group
    +"&year="+this.year

     return new Promise(function (resolve, reject) {
        axios.get(dashboardUri).then(
            (response) => {
                var result = response.data.dashboardData;
                console.log('Processing Request');
                resolve(result);
            },
                (error) => {
                reject(error);
            }
        );
    });
     
  },
    async downloadData()
  {
    if(this.group !=='-Select-' && this.year !=='-Select-') 
    {
    this.responseData = await  this.getDataPromise();
    if(this.responseData) {
      this.responseData.filter(obj => {
                                                          obj.requestDate = moment(obj.requestDate).format('MMM')
                                                        })								
                        const convertArrayToObject = (array, key) => {
                                                    const initialValue = {};
                                                    return array.reduce((obj, item) => {
                                                          return {
                                                          ...obj,
                                                          [item[key]]: item,
                                                          };
                                                      }, initialValue);
                                                    };
                      
                        this.convertedObj =convertArrayToObject(this.responseData,'requestDate' );
                        console.log(this.convertedObj);
                        if(this.monthArray) {
                        this.monthArray.length =0;
                        this.requestRaised.length =0;
                        this.responseRaised.length =0;
                        this.responsePercent.length =0;
                        }
                        this.monthArray = Object.keys(this.convertedObj)
                        this.monthArray.forEach(element => {
                          this.requestRaised.push(this.convertedObj[element].requestCount);
                          this.responseRaised.push(this.convertedObj[element].responseCount)
                          this.responsePercent.push(this.convertedObj[element].responseCount / this.convertedObj[element].requestCount * 100)
                        });
                        
                        
                   
                    console.log("beforesRender")
    this.renderHighchart();
    console.log("afterRender")
    }
    else {
    alert("No Data found !!!");
    }
                        
  }
    },
    renderHighchart () {
      if (this.chart) {
        this.chart.destroy();
      }
      this.chart = Highcharts.chart('container', {
    chart: {
        zoomType: 'xy',
        alignTicks: false,
    },
    credits: {
      enabled: false
    },
    title: {
        text: 'Monthly Feedback Response',
        align: 'left'
    },
    xAxis: [{
        categories: this.monthArray,
        crosshair: true
    }],
    yAxis: [{ // Primary yAxis
        labels: {
            format: '{value}',
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        },
        title: {
            text: 'Response Rate in %',
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        },
        max:100,
        opposite: true

    }, { // Secondary yAxis
        gridLineWidth: 0,
        title: {
            text: 'No of Feedback Request Raised & Response Received',
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        },
        max:Math.max( ...this.requestRaised),
        labels: {
            format: '{value}',
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }

    }
    // , { // Tertiary yAxis
    //     gridLineWidth: 0,
    //     title: {
    //         text: 'Sea-Level Pressure',
    //         style: {
    //             color: Highcharts.getOptions().colors[1]
    //         }
    //     },
    //     labels: {
    //         format: '{value} ',
    //         style: {
    //             color: Highcharts.getOptions().colors[1]
    //         }
    //     },
    //     opposite: true
    // }
    ],
    tooltip: {
        shared: true
    },
    legend: {
        layout: 'vertical',
        align: 'right',
        x: 10,
        verticalAlign: 'top',
        y: 80,
        floating: false,
        backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || // theme
            'rgba(255,255,255,0.25)'
    },
    series: [{
        name: 'Request Raised',
        type: 'column',
        yAxis: 1,
        data: this.requestRaised,
        tooltip: {
            valueSuffix: ' '
        },
        color: 'red'

    },{
        name: 'Response Received',
        type: 'column',
        yAxis: 1,
        data: this.responseRaised,
        tooltip: {
            valueSuffix: ' '
        },
        color: '#0000ff'

    }, 
    // {
    //     name: 'Sea-Level Pressure',
    //     type: 'spline',
    //     yAxis: 2,
    //     data: [1016, 1016, 1015.9, 1015.5, 1012.3, 1009.5, 1009.6, 1010.2, 1013.1, 1016.9, 1018.2, 1016.7],
    //     marker: {
    //         enabled: false
    //     },
    //     dashStyle: 'shortdot',
    //     tooltip: {
    //         valueSuffix: ' mb'
    //     }

    // },
     {
        name: 'Response Rate',
        type: 'spline',
        data: this.responsePercent,
        tooltip: {
            valueDecimals: 2,
            valueSuffix: ' %'
            
        },
        color: '#035721'
    }],
    responsive: {
        rules: [{
            condition: {
                maxWidth: 500
            },
            chartOptions: {
                legend: {
                    floating: false,
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom',
                    x: 0,
                    y: 0
                },
                yAxis: [{
                    labels: {
                        align: 'right',
                        x: 0,
                        y: -6
                    },
                    showLastLabel: false
                }, {
                    labels: {
                        align: 'left',
                        x: 0,
                        y: -6
                    },
                    showLastLabel: false
                }, {
                    visible: false
                }]
            }
        }]
    }
});
    },
    
  }
};
</script>
<style scoped>
.highcharts-figure, .highcharts-data-table table {
  min-width: 310px; 
  max-width: 800px;
  margin: 1em auto;
}

#container {
  height: 400px;
}

.highcharts-data-table table {
	font-family: Verdana, sans-serif;
	border-collapse: collapse;
	border: 1px solid #EBEBEB;
	margin: 10px auto;
	text-align: center;
	width: 100%;
	max-width: 500px;
}
.highcharts-data-table caption {
  padding: 1em 0;
  font-size: 1.2em;
  color: #0000FF;
}
.highcharts-data-table th {
	font-weight: 600;
  padding: 0.5em;
}
.highcharts-data-table td, .highcharts-data-table th, .highcharts-data-table caption {
  padding: 0.5em;
}
.highcharts-data-table thead tr, .highcharts-data-table tr:nth-child(even) {
  background: #f8f8f8;
}
.highcharts-data-table tr:hover {
  background: #f1f7ff;
}
.grayout {
    opacity: 0.6; /* Real browsers */
    filter: alpha(opacity = 60); /* MSIE */
}
.mumbai{
width: 160px;
margin-top:10px;
height: 25px;
}
</style>